module.exports = __webpack_public_path__ + "assets/images/business_reg_hint@2x.png";